module.exports = __webpack_public_path__ + "img/natalia-perello.0f058230.jpg";